import React from 'react'
import { ReactComponent as ArrowRolloverScrollSvg} from '../../assets/svgs/arrows/Arrow_Rollover_Scroll.svg';

const ArrowRolloverScrollIcon = () => (
    <div>
        <ArrowRolloverScrollSvg/>
    </div>
)

export default ArrowRolloverScrollIcon